import PassportService from "src/services/PassportService";
import ModuleCreator from "src/store/ModuleCreator";

export const types = {
	REMOVE: "authclient/remove",
};
export const params = {};
/**
 @namespace
 @property  {object} module,
 @property  {object} module.state,
 @property  {object} modules.game,
 @property  {array}  modules.games
 **/

const module = {
	state: {
	},
	mutations: {
		[types.REMOVE] (state, obj) {
			state[obj] = PassportService.removeFromArray(state[obj], obj);
		},
	},
	getters: {},
	actions: {
		[types.REMOVE] ({ commit }, data) {
			return PassportService.remove(data.id).then(() => {
				commit([types.REMOVE], {});
			});
		},
	},
	types: types,
};
export default ModuleCreator("authclient", PassportService, module, types, params);
